export const getSavingsCalloutText = (raw?: string): string => {
    const text = raw?.trim() ?? "";
    if (!text) {
        return "";
    }

    const amountMatch = text.replace(/,/g, "").match(/(\d+(?:\.\d+)?)/);
    const amount = amountMatch ? Number(amountMatch[1]) : NaN;

    if (!amountMatch || amount <= 0) {
        return "";
    }

    return `₹${amount} Saved`;
};
